export default __webpack_public_path__ + "src/images/packages/witklipfontein-eco-lodge/11dccb6a1ab4d5f919df5d8c64a86d35-3.jpg";